import React from "react";
import { Link } from "react-router-dom";

const Section = ({ title, children }) => (
  <div style={{ marginBottom: 40 }}>
    <h2 style={{
      color: "#f5c200",
      fontWeight: 800,
      fontSize: "1.1rem",
      textTransform: "uppercase",
      letterSpacing: "0.1em",
      marginBottom: 12,
      borderLeft: "4px solid #2a7a6f",
      paddingLeft: 14,
    }}>
      {title}
    </h2>
    <div style={{ color: "#ccc", fontSize: "0.95rem", lineHeight: 1.8 }}>
      {children}
    </div>
  </div>
);

const Article = ({ number, title, children }) => (
  <div style={{
    background: "#1a1a1a",
    border: "1px solid #2a2a2a",
    borderRadius: 8,
    padding: "20px 24px",
    marginBottom: 16,
  }}>
    <div style={{
      color: "#f5c200",
      fontWeight: 700,
      fontSize: "0.82rem",
      textTransform: "uppercase",
      letterSpacing: "0.1em",
      marginBottom: 6,
    }}>
      Article {number}
    </div>
    <div style={{ color: "#f7f4ee", fontWeight: 700, marginBottom: 10 }}>{title}</div>
    <div style={{ color: "#aaa", fontSize: "0.9rem", lineHeight: 1.7 }}>{children}</div>
  </div>
);

export default function CGU() {
  return (
    <div style={{ background: "#0d1117", minHeight: "100vh", paddingBottom: 80 }}>
      {/* Header */}
      <div style={{
        background: "#1a1a1a",
        borderBottom: "3px solid #f5c200",
        padding: "60px 24px 40px",
        textAlign: "center",
      }}>
        <div style={{ fontSize: "2.5rem", marginBottom: 12 }}>📋</div>
        <h1 style={{
          color: "#f7f4ee",
          fontWeight: 900,
          fontSize: "clamp(1.6rem, 4vw, 2.5rem)",
          marginBottom: 12,
        }}>
          Conditions Générales d'Utilisation
        </h1>
        <p style={{ color: "#aaa", fontSize: "0.95rem", maxWidth: 560, margin: "0 auto" }}>
          Dernière mise à jour : juin 2026 — Starting Five, Lomé, Togo
        </p>
      </div>

      {/* Contenu */}
      <div style={{ maxWidth: 860, margin: "0 auto", padding: "48px 24px" }}>

        <Section title="Préambule">
          <p>
            Les présentes Conditions Générales d'Utilisation (ci-après « CGU ») régissent l'accès et
            l'utilisation du site internet de <strong style={{ color: "#f7f4ee" }}>Starting Five</strong>
            {" "}(ci-après « le Site »), édité par la société Starting Five, dont le siège social est
            situé Cité Mokpokpo, Adidogomé Lomé, Togo.
          </p>
          <p style={{ marginTop: 12 }}>
            En accédant au Site, vous acceptez sans réserve les présentes CGU. Si vous n'acceptez pas ces
            conditions, vous devez cesser immédiatement d'utiliser le Site.
          </p>
        </Section>

        <Article number="1" title="Objet">
          Le Site a pour objet de présenter les activités, services et actualités du groupe Starting Five,
          ainsi que de permettre aux utilisateurs de s'inscrire, de se connecter et d'accéder à certains
          services proposés par le groupe.
        </Article>

        <Article number="2" title="Accès au site">
          Le Site est accessible gratuitement à tout utilisateur disposant d'un accès à Internet. Les
          coûts d'accès à Internet sont à la charge de l'utilisateur. Starting Five se réserve le droit
          de modifier, suspendre ou interrompre l'accès au Site, à tout moment et sans préavis, notamment
          pour des raisons de maintenance ou de mise à jour.
        </Article>

        <Article number="3" title="Création de compte">
          Certains services du Site nécessitent la création d'un compte personnel. L'utilisateur s'engage
          à fournir des informations exactes, complètes et à jour lors de son inscription. Toute utilisation
          frauduleuse du compte est de la seule responsabilité de l'utilisateur. Starting Five se réserve
          le droit de supprimer tout compte ne respectant pas les présentes CGU.
        </Article>

        <Article number="4" title="Propriété intellectuelle">
          L'ensemble des contenus présents sur le Site (textes, images, logos, vidéos, etc.) sont la
          propriété exclusive de Starting Five ou de ses partenaires. Toute reproduction, représentation
          ou utilisation, même partielle, sans autorisation préalable et écrite de Starting Five est
          strictement interdite et pourra faire l'objet de poursuites.
        </Article>

        <Article number="5" title="Responsabilité">
          Starting Five s'efforce d'assurer l'exactitude des informations publiées sur le Site mais ne
          peut garantir leur exhaustivité. L'utilisation du Site se fait sous la seule responsabilité de
          l'utilisateur. Starting Five ne saurait être tenu responsable de dommages directs ou indirects
          résultant de l'utilisation du Site.
        </Article>

        <Article number="6" title="Liens hypertextes">
          Le Site peut contenir des liens vers des sites tiers. Ces liens sont fournis à titre informatif.
          Starting Five n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à
          leur contenu ou leur politique de confidentialité.
        </Article>

        <Article number="7" title="Données personnelles">
          Le traitement de vos données personnelles est régi par notre Politique de Confidentialité,
          accessible depuis le footer du Site. Conformément à la législation applicable, vous disposez
          d'un droit d'accès, de rectification et de suppression de vos données.
        </Article>

        <Article number="8" title="Modification des CGU">
          Starting Five se réserve le droit de modifier les présentes CGU à tout moment. Les nouvelles
          conditions entrent en vigueur dès leur publication sur le Site. Il appartient à l'utilisateur
          de consulter régulièrement les CGU en vigueur.
        </Article>

        <Article number="9" title="Droit applicable et juridiction compétente">
          Les présentes CGU sont soumises au droit togolais. En cas de litige, et à défaut de résolution
          amiable, les tribunaux compétents de Lomé (Togo) seront seuls compétents.
        </Article>

        <Section title="Contact">
          <p>Pour toute question relative aux présentes CGU, vous pouvez nous contacter :</p>
          <div style={{
            marginTop: 16,
            background: "#1a1a1a",
            border: "1px solid #2a2a2a",
            borderRadius: 8,
            padding: "20px 24px",
            display: "inline-block",
          }}>
            <div style={{ color: "#f7f4ee", fontWeight: 700, marginBottom: 8 }}>Starting Five</div>
            <div style={{ color: "#aaa", fontSize: "0.9rem", lineHeight: 2 }}>
              📧 contact@startingfive.tg<br />
              📞 +228 90 47 87 25<br />
              📍 Cité Mokpokpo, Adidogomé Lomé, Togo
            </div>
          </div>
        </Section>

        {/* Retour */}
        <div style={{ marginTop: 48, textAlign: "center" }}>
          <Link to="/" style={{
            color: "#2a7a6f",
            textDecoration: "none",
            fontWeight: 600,
            fontSize: "0.95rem",
          }}>
            ← Retour à l'accueil
          </Link>
        </div>
      </div>
    </div>
  );
}
